(function () {
  'use strict';

  var HS = {
    data: [],
    currentIndex: 0,
    overlay: null,
    cache: {},

    init: function () {
      var el = document.getElementById('hs-data');
      if (!el) return;
      try { this.data = JSON.parse(el.textContent || '[]'); } catch (e) { return; }
      if (!this.data.length) return;
      var self = this;
      // Delay lets Impulse finish its own gallery init
      setTimeout(function () { self.setup(); }, 300);
    },

    setup: function () {
      this.overlay = document.createElement('div');
      this.overlay.className = 'hs-overlay';
      var slide = this.getSlide(0);
      if (!slide) return;
      this.ensureRelative(slide);
      slide.appendChild(this.overlay);
      this.paint(0);
      this.listen();
    },

    getSlide: function (idx) {
  var nodes = document.querySelectorAll('.product-main-slide');
  return nodes[idx] || nodes[0] || null;
},

    ensureRelative: function (el) {
      if (el && getComputedStyle(el).position === 'static') el.style.position = 'relative';
    },

    paint: function (idx) {
      if (!this.overlay) return;
      this.overlay.innerHTML = '';
      var self = this;
      this.data
        .filter(function (h) { return h.image_index === idx; })
        .forEach(function (h) { self.overlay.appendChild(self.buildDot(h)); });
    },

    buildDot: function (h) {
      var self = this;
      var wrap = document.createElement('div');
      wrap.className = 'hs-hotspot';
      wrap.style.cssText = 'left:' + h.x + '%;top:' + h.y + '%';

      wrap.innerHTML =
        '<div class="hs-pulse"></div>' +
        '<div class="hs-dot"></div>' +
        '<div class="hs-preview hs-preview--right hs-preview--bottom" style="display:none">' +
          '<img class="hs-preview__img" src="" alt="" />' +
          '<div class="hs-preview__body">' +
            '<span class="hs-preview__title">Loading\u2026</span>' +
            '<span class="hs-preview__price"></span>' +
            '<a class="hs-preview__btn" href="/products/' + h.product_handle + '">View Product</a>' +
          '</div>' +
        '</div>';

      var card = wrap.querySelector('.hs-preview');
      var fetched = false;
      var touchOpen = false;

      function show() {
        self.orient(wrap, card);
        card.style.display = 'block';
        if (!fetched) { fetched = true; self.fetch(h.product_handle, wrap); }
      }
      function hide() { card.style.display = 'none'; touchOpen = false; }

      var hideTimer;

wrap.addEventListener('mouseenter', function () {
  clearTimeout(hideTimer);
  show();
});
wrap.addEventListener('mouseleave', function () {
  hideTimer = setTimeout(hide, 300);
});

card.style.pointerEvents = 'all';
card.addEventListener('mouseenter', function () {
  clearTimeout(hideTimer);
});
card.addEventListener('mouseleave', function () {
  hideTimer = setTimeout(hide, 150);
});

wrap.addEventListener('touchstart', function (e) {
  if (e.target.closest && e.target.closest('.hs-preview')) return; 
  e.preventDefault(); e.stopPropagation();
  touchOpen ? hide() : (touchOpen = true, show());
}, { passive: false });


wrap.addEventListener('click', function (e) {
  if (e.target.closest && e.target.closest('.hs-preview')) return; 
  window.location.href = '/products/' + h.product_handle;
});

      return wrap;
    },

    orient: function (hotspot, card) {
      if (!this.overlay) return;
      var or = this.overlay.getBoundingClientRect();
      var hr = hotspot.getBoundingClientRect();
      var cx = (hr.left + hr.width / 2 - or.left) / or.width;
      var cy = (hr.top + hr.height / 2 - or.top) / or.height;
      card.className = 'hs-preview' +
        (cx > 0.54 ? ' hs-preview--left' : ' hs-preview--right') +
        (cy > 0.58 ? ' hs-preview--top'  : ' hs-preview--bottom');
    },

    fetch: function (handle, wrap) {
  var self = this;
  // Strip UTM params so the .js product endpoint resolves correctly
  var cleanHandle = handle.split('?')[0].split('#')[0];
  if (self.cache[cleanHandle]) { self.fill(self.cache[cleanHandle], wrap); return; }
  window.fetch('/products/' + cleanHandle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (p) { self.cache[cleanHandle] = p; self.fill(p, wrap); })
    .catch(function () {
      var t = wrap.querySelector('.hs-preview__title');
      if (t) t.textContent = 'View Product';
    });
},

    fill: function (p, wrap) {
      var img   = wrap.querySelector('.hs-preview__img');
      var title = wrap.querySelector('.hs-preview__title');
      var price = wrap.querySelector('.hs-preview__price');
      if (img)   img.src = p.featured_image || '';
      if (title) title.textContent = p.title;
      if (price) {
        price.textContent = (window.Shopify && Shopify.formatMoney)
          ? Shopify.formatMoney(p.price)
          : '\u20B9' + (p.price / 100).toFixed(2);
      }
    },

    moveTo: function (idx) {
      if (idx === this.currentIndex) return;
      this.currentIndex = idx;
      var self = this;
      setTimeout(function () {
        if (self.overlay && self.overlay.parentNode) self.overlay.parentNode.removeChild(self.overlay);
        var slide = self.getSlide(idx);
        if (!slide) return;
        self.ensureRelative(slide);
        slide.appendChild(self.overlay);
        self.paint(idx);
      }, 60);
    },

    probe: function () {
      var self = this;
      var slides = document.querySelectorAll('.product-main-slide');
      slides.forEach(function (s, i) {
        if ((s.classList.contains('is-selected') ||
             s.classList.contains('is-active') ||
             s.classList.contains('product__media-item--active') ||
             s.getAttribute('aria-hidden') === 'false' ||
             s.getAttribute('data-media-active') === 'true') && i !== self.currentIndex) {
          self.moveTo(i);
        }
      });
    },

    listen: function () {
      var self = this;

      // 1. MutationObserver
      var gallery = document.querySelector([
        '[data-product-slideshow]','.product-slideshow',
        '.product__media-list','.product-single__photos'
      ].join(','));
      if (gallery) {
        new MutationObserver(function () { self.probe(); })
          .observe(gallery, { attributes: true, subtree: true,
            attributeFilter: ['class','aria-hidden','data-media-active'] });
      }

      // 2. Thumbnail clicks
      document.querySelectorAll('[data-product-thumb]').forEach(function (t, i) {
        t.addEventListener('click', function () {
          setTimeout(function () { self.moveTo(i); }, 90);
        });
      });

      // 3. Impulse custom event
      document.addEventListener('theme:media:select', function (e) {
        if (e.detail && !isNaN(+e.detail.index)) self.moveTo(+e.detail.index);
      });

      // 4. Flickity
      var flkEl = document.querySelector('[data-product-slideshow]');
      if (flkEl && window.Flickity) {
        var flk = Flickity.data(flkEl);
        if (flk) flk.on('select', function () { self.moveTo(flk.selectedIndex); });
      }

      // 5. Arrow keys / swipe safety net
      ['keydown','touchend'].forEach(function (ev) {
        document.addEventListener(ev, function () {
          setTimeout(function () { self.probe(); }, 160);
        });
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { HS.init(); });
  } else {
    HS.init();
  }
})();